/* eslint-disable */
import { useQuery } from '@tanstack/react-query';
import {
  getProductTimeline,
  getAreas,
  type GetProductTimelineParams,
} from '../services/productDashboardApi';
import type {
  ProductTimelineResponse,
  AreaListResponse,
} from '../types/productDashboard';

export function useProductTimeline(
  params: GetProductTimelineParams = {}
) {
  return useQuery<ProductTimelineResponse, Error>({
    queryKey: ['productTimeline', params],
    queryFn: () => getProductTimeline(params),
    enabled: true,
  });
}

export function useAreas() {
  return useQuery<AreaListResponse, Error>({
    queryKey: ['productDashboardAreas'],
    queryFn: () => getAreas(),
    enabled: true,
  });
}
